// extracted by mini-css-extract-plugin
module.exports = {"container":"PostSummary_container__zQj2N","content":"PostSummary_content__VtCPq"};